import React, { useState } from 'react';
import { ChevronDown, ChevronUp, ChevronRight, ChevronLeft } from 'lucide-react';
import './Collapsible.scss';

interface CollapsibleProps {
  title?: React.ReactNode;
  defaultCollapsed?: boolean;
  collapsed?: boolean;
  onToggle?: () => void;
  children: React.ReactNode;
  className?: string;
  headerClassName?: string;
  /** Extra content rendered in the header row (between title and chevron) */
  headerRight?: React.ReactNode;
  /** Line after header when collapsed */
  divider?: boolean;
}

const Collapsible: React.FC<CollapsibleProps> = ({
  title,
  defaultCollapsed = true,
  collapsed: controlledCollapsed,
  onToggle,
  children,
  className,
  headerClassName,
  headerRight,
  divider,
}) => {
  const [internalCollapsed, setInternalCollapsed] = useState(defaultCollapsed);
  const isControlled = controlledCollapsed !== undefined;
  const isCollapsed = isControlled ? controlledCollapsed : internalCollapsed;

  const handleToggle = () => {
    if (onToggle) onToggle();
    if (!isControlled) setInternalCollapsed(c => !c);
  };

  return (
    <div className={`collapsible${isCollapsed ? ' collapsible--collapsed' : ''}${className ? ` ${className}` : ''}`}>
      <button
        className={`collapsible__header${headerClassName ? ` ${headerClassName}` : ''}${divider ? ' collapsible__header--divider' : ''}`}
        onClick={handleToggle}
        type="button"
      >
        {title && <span className="collapsible__title">{title}</span>}
        {headerRight && <span className="collapsible__header-right">{headerRight}</span>}
        <span className="collapsible__chevron">
          <span className="collapsible__chevron-mobile">
            {isCollapsed ? <ChevronDown size={14} /> : <ChevronUp size={14} />}
          </span>
          <span className="collapsible__chevron-desktop">
            {isCollapsed ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
          </span>
        </span>
      </button>
      {!isCollapsed && (
        <div className="collapsible__content">
          {children}
        </div>
      )}
    </div>
  );
};

export default Collapsible;
